import { useEffect } from "react";
import CustomButton from "../../../../components/custom/CustomButton";
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Form,
  DatePicker,
  Divider,
  Modal,
  List,
  Button,
} from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

const STATIC_OFFICE_TYPE_OPTIONS = [
  { label: "Head Office", value: 1 },
  { label: "Branch", value: 2 },
  { label: "Regional Branch", value: 3 },
];

const AddressModal = ({
  countryIdData,
  stateProvinceIdData,
  addressTypeIdData,
  isModalOpen,
  setIsModalOpen,
  addressList,
  setAddressList,
  BOM,
  staticConfig,
}) => {
  const [addressForm] = Form.useForm();

  const handleAddressSave = (values) => {
    const addressType = addressTypeIdData?.find(
      (item) => item.value === values.addressTypeId,
    );
    const stateProvince = stateProvinceIdData?.find(
      (item) => item.value === values.stateProvinceId,
    );
    const country = countryIdData?.find(
      (item) => item.value === values.countryId,
    );

    const newAddress = {
      id: values.addressTypeId,
      title: addressType?.label,
      description: `${values.addressLine1}${values.addressLine2 ? ", " + values.addressLine2 : ""}, ${values.city}, ${stateProvince?.label}, ${country?.label}${values.postalCode ? ", " + values.postalCode : ""}`,
      addressLine1: values.addressLine1,
      addressLine2: values.addressLine2,
      addressTypeId: values.addressTypeId,
      city: values.city,
      countryId: values.countryId,
      isActive: values.isActive,
      postalCode: values.postalCode,
      stateProvinceId: values.stateProvinceId,
    };

    setAddressList([...addressList, newAddress]);
    addressForm.resetFields();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => setIsModalOpen(true)}
        icon={<PlusCircleOutlined />}
        shape="round"
        className="of-primaryBtnColor"
      >
        Add Address
      </Button>

      <Modal
        title="Address Information"
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        width={900}
      >
        <Form form={addressForm} layout="vertical" onFinish={handleAddressSave}>
          <Divider />
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="addressTypeId"
                label={<Text strong>Address Type</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select address type"
                  options={addressTypeIdData}
                  showSearch
                  style={{ height: 44 }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="addressLine1"
                label={<Text strong>Address Line 1</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input
                  placeholder="Enter address line 1"
                  style={{ height: 44 }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="addressLine2"
                label={<Text strong>Address Line 2</Text>}
              >
                <Input
                  placeholder="Enter address line 2"
                  style={{ height: 44 }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="city"
                label={<Text strong>City</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Enter city" style={{ height: 44 }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="countryId"
                label={<Text strong>Country</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select country"
                  options={countryIdData}
                  showSearch
                  style={{ height: 44 }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="stateProvinceId"
                label={<Text strong>State / Province</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select state/province"
                  options={stateProvinceIdData}
                  showSearch
                  style={{ height: 44 }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="postalCode"
                label={<Text strong>Postal Code</Text>}
              >
                <Input placeholder="Enter postal code" style={{ height: 44 }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="isActive"
                label={<Text strong>Status</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Select
                  placeholder="Select status"
                  options={[
                    { label: "Active", value: true },
                    { label: "Inactive", value: false },
                  ]}
                  style={{ height: 44 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row>
            <CustomButton
              content="Save"
              htmlType="submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#15CCAE"
              colorText="black"
              hoverBackground="#4FECA0"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </>
  );
};

const BranchForm = ({
  parentBranch = [],
  officeTypeOptions = [],
  nearestBranchOptions = [],
  countryIdData = [],
  stateProvinceIdData = [],
  addressTypeIdData = [],
  addressList = [],
  setAddressList,
  isModalOpen,
  setIsModalOpen,
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const currentYear = dayjs().year();

  const disabledDate = (current) =>
    current.year() !== currentYear || current > dayjs().endOf("day");

  useEffect(() => {
    if (parentBranch.length > 0) {
      form.setFieldsValue({
        openedOn: dayjs(),
        parentBranch: parentBranch[0].value,
      });
    }
  }, [parentBranch]);

  const handleSubmit = (values) => {
    const body = {
      parentId: values.parentBranch,
      name: values.name,
      externalId: values.externalId || "",
      openingDate: values.openedOn
        ? dayjs(values.openedOn).format("DD MMMM YYYY")
        : null,
      // officeTypeId: values.officeTypeId,
      nearestBranchId: values.nearestBranchId,
      // address: addressList,
      method: "POST",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Office, (err) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Branch Created Successfully");
        navigate("/sya0200");
        setIsLoading(false);
      }
    });
  };

  const onCancel = () => navigate("/sya0200", { replace: false });

  const handleAddressDelete = (item) => {
    setAddressList(addressList.filter((a) => a.id !== item.id));
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={handleSubmit}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginBottom: 24,
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#9ca3af",
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
        >
          Branch Information
        </div>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="name"
              label={<Text strong>Branch</Text>}
              rules={[{ required: true, message: "Required Field" }]}
            >
              <Input placeholder="Enter branch name" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="parentBranch"
              label={<Text strong>Parent Branch</Text>}
              rules={[{ required: true, message: "Required Field" }]}
            >
              <Select
                placeholder="Select a parent branch"
                style={{ height: 44 }}
                options={parentBranch}
                showSearch
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="officeTypeId"
              label={<Text strong>Office Type</Text>}
              rules={[{ required: true, message: "Required Field" }]}
            >
              <Select
                placeholder="Select an Option"
                style={{ height: 44 }}
                options={
                  officeTypeOptions.length
                    ? officeTypeOptions
                    : STATIC_OFFICE_TYPE_OPTIONS
                }
                showSearch
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="openedOn"
              label={<Text strong>Opened On</Text>}
              rules={[{ required: true, message: "Required Field" }]}
            >
              <DatePicker
                style={{ width: "100%", height: 44 }}
                disabledDate={disabledDate}
                format="DD MMMM YYYY"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="externalId"
              label={<Text strong>Branch Code</Text>}
            >
              <Input placeholder="Enter branch code" style={{ height: 44 }} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="nearestBranchId"
              label={<Text strong>Nearest Branch</Text>}
            >
              <Select
                placeholder="Select an Option"
                style={{ height: 44 }}
                options={nearestBranchOptions}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>

        <Divider />

        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#9ca3af",
            letterSpacing: 1,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
        >
          Address Information
        </div>

        <AddressModal
          countryIdData={countryIdData}
          stateProvinceIdData={stateProvinceIdData}
          addressTypeIdData={addressTypeIdData}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          addressList={addressList}
          setAddressList={setAddressList}
          BOM={BOM}
        />

        {addressList.length > 0 && (
          <List
            style={{ marginTop: 16 }}
            dataSource={addressList}
            renderItem={(item) => (
              <Card
                style={{
                  width: "100%",
                  marginBottom: 12,
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                }}
                bodyStyle={{ padding: "12px 16px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div
                      style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}
                    >
                      {item.title?.toUpperCase()}
                    </div>
                    <div style={{ color: "#6b7280", fontSize: 13 }}>
                      {item.description}
                    </div>
                  </div>
                  <Button
                    type="link"
                    danger
                    onClick={() => handleAddressDelete(item)}
                    icon={<DeleteOutlined />}
                    style={{ padding: 0 }}
                  >
                    Remove
                  </Button>
                </div>
              </Card>
            )}
          />
        )}
      </Card>

      <Form.Item style={{ marginBottom: 0 }}>
        <Row>
          <CustomButton
            content="Submit"
            htmlType="submit"
            style={{
              width: "10%",
              marginLeft: "auto",
              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            }}
            backgroundColor="#15CCAE"
            colorText="black"
            hoverBackground="#4FECA0"
          />
          <CustomButton
            content="Cancel"
            style={{
              width: "10%",
              marginLeft: "1%",
              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            }}
            backgroundColor="#fff"
            colorText="black"
            hoverBackground="#F5F5F5"
            onClick={onCancel}
          />
        </Row>
      </Form.Item>
    </Form>
  );
};

export default BranchForm;
